module.exports = require('./lib/_stream_writable.js');



//////////////////
// WEBPACK FOOTER
// ../~/readable-stream/writable-browser.js
// module id = 822
// module chunks = 0